// extracted by mini-css-extract-plugin
export default {"editButton":"addDeduction_editButton__VnV9f","TableBody":"addDeduction_TableBody__80PZh","deleteButton":"addDeduction_deleteButton__W2r0k"};